<template>
  <div class="indexPage custom_style">
    <div class="head flex-rowl">
      <i class="iconfont icon-huiyuan"></i>
      <div class="content">
        <h1>更新客户信息</h1>
        <p>新增客户</p>
      </div>
    </div>
    <div class="container_wrap">
      <div class="form_wrap">
        <div class="block">
          <div class="item">
            <div class="label">
              <i class="iconfont icon-bitian"></i> 客户姓名
            </div>
            <div class="input">
              <van-field
                v-model="formData.info_truename"
                placeholder="请输入客户姓名"
              />
            </div>
          </div>
          <div class="item">
            <div class="label">
              <i class="iconfont icon-bitian"></i> 企业名称
            </div>
            <div class="input flex-between" @click="handleShow(7)">
            <!-- <div class="input flex-between" @click="handleShow(7)"> -->
              <van-field
                v-model="other_companystr"
                placeholder="请输入企业名称"
                readonly
              />
              <i class="iconfont icon-bottom"></i>
            </div>
          </div>
          <div class="item">
            <div class="label"><i class="iconfont icon-bitian"></i> 职务：</div>
            <div class="input">
              <van-field
                v-model="formData.other_job"
                placeholder="请输入职务"
                readonly
              />
            </div>
          </div>
          <div class="item">
            <div class="label">
              <i class="iconfont icon-bitian"></i> 联系方式：
            </div>
            <div class="input">
              <van-field
                v-model="formData.info_mobile"
                placeholder="请输入联系方式"
                readonly
              />
            </div>
          </div>
        </div>
        <div class="block customer_wrap">
          <div class="title">客户标签：</div>
          <div class="label_list flex-rowc">
            <div
              class="item flex-between"
              v-for="item in customerOptin"
              :key="item.id"
              @click="formData.info_tag_id = item.id"
            >
              {{ item.labelname }}
              <i
                class="iconfont icon-3tuihuanhuozhengcegouxuan"
                v-if="item.id == formData.info_tag_id"
              ></i>
            </div>
          </div>
        </div>
        <div class="block classify_wrap">
          <div class="item">
            <div class="input flex-between" @click="handleShow(4)">
              <van-field
                v-model="other_typestr"
                placeholder="请选择补充分类"
                readonly
              />
              <i class="iconfont icon-bottom"></i>
            </div>
          </div>
          <div class="item">
            <div class="input flex-between" @click="handleShow(5)">
              <van-field
                v-model="other_attrstr"
                placeholder="请选择客户属性"
                readonly
              />
              <i class="iconfont icon-bottom"></i>
            </div>
          </div>
          <div class="item">
            <div class="input flex-between" @click="handleShow(6)">
              <van-field
                v-model="other_yxdstr"
                placeholder="请选择联系优先度"
                readonly
              />
              <i class="iconfont icon-bottom"></i>
            </div>
          </div>
        </div>
        <div class="block address_wrap">
          <div class="title flex-rowl">
            <div class="icon_box flex-rowc">
              <i class="iconfont icon-weibiaoti-3"></i>
            </div>
            所在地区
          </div>
          <div class="item">
            <div class="input flex-between" @click="handleShow(1)">
              <van-field
                v-model="provinceTxt"
                placeholder="选择省/直辖市"
                readonly
              />
              <i class="iconfont icon-bottom"></i>
            </div>
          </div>
          <div class="item">
            <div class="input flex-between" @click="handleShow(2)">
              <van-field v-model="cityTxt" placeholder="选择城市" readonly />
              <i class="iconfont icon-bottom"></i>
            </div>
          </div>
          <div class="item">
            <div class="input flex-between" @click="handleShow(3)">
              <van-field
                v-model="areaTxt"
                placeholder="选择所在区域"
                readonly
              />
              <i class="iconfont icon-bottom"></i>
            </div>
          </div>
          <div class="item detail">
            <div class="tit">详细地址</div>
            <div class="textarea">
              <van-field
                v-model="formData.other_address"
                type="textarea"
                placeholder="请填写详细地址，50个字符内"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="custom_btn" @click="query">保存</div>
    </div>
    <!-- <div class="custom_btn return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i> 返回
    </div> -->
    <div class="primary-button return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i> 返回
    </div>

    <!-- 弹窗 start -->
    <van-popup
      v-model="isShowPopup"
      position="bottom"
      :style="{ height: '40%' }"
    >
      <div v-if="isType == 1">
        <van-picker
          show-toolbar
          :columns="provinceList"
          @confirm="onConfirm"
          @cancel="isShowPopup = false"
          :loading="loading"
          v-if="provinceList.length > 0"
        />
        <van-empty
          v-else-if="provinceList.length == 0 && !loading"
          description="暂无选项"
        />
      </div>
      <div v-else-if="isType == 2">
        <van-picker
          show-toolbar
          :columns="cityList"
          @confirm="onConfirm"
          @cancel="isShowPopup = false"
          :loading="loading"
          v-if="cityList.length > 0"
        />
        <van-empty
          v-else-if="cityList.length == 0 && !loading"
          description="暂无选项"
        />
      </div>
      <div v-else-if="isType == 3">
        <van-picker
          show-toolbar
          :columns="areaList"
          @confirm="onConfirm"
          @cancel="isShowPopup = false"
          :loading="loading"
          v-if="areaList.length > 0"
        />
        <van-empty
          v-else-if="areaList.length == 0 && !loading"
          description="暂无选项"
        />
      </div>
      <div v-else-if="isType == 4">
        <van-picker
          show-toolbar
          :columns="columnOne"
          @confirm="onConfirm"
          @cancel="isShowPopup = false"
        />
      </div>
      <div v-else-if="isType == 5">
        <van-picker
          show-toolbar
          :columns="columnTwo"
          @confirm="onConfirm"
          @cancel="isShowPopup = false"
        />
      </div>
      <div v-else-if="isType == 6">
        <van-picker
          show-toolbar
          :columns="columnThree"
          @confirm="onConfirm"
          @cancel="isShowPopup = false"
        />
      </div>
      <div v-else-if="isType == 7">
        <van-picker
          show-toolbar
          :columns="customerQy"
          @confirm="onConfirm"
          @cancel="isShowPopup = false"
        />
      </div>
    </van-popup>
    <!-- 弹窗 end -->
  </div>
</template>
<script>
import {
  getProvince,
  getCity,
  getArea,
  getQywxset,
  getCustomerDetail,
  getCustomerLabel,
  addCustomer,
  encryptstringview
} from "../../api/api";
import { getCustomQyList } from "../../api/company";
export default {
  name: "addCustomer",
  data() {
    return {
      id: "",
      qyguid: "",
      type: "",
      formData: {
        qyguid: '',
        ext_name: '',  // 客户昵称
        info_remark: "",  // 企业员工姓名
        info_truename: '',  // 客户真实姓名
        other_company: "",
        other_job: "",
        info_remark_mobiles: "",
        info_mobile: '',
        info_tag_id: "",
        other_type: "",
        other_attr: "",
        other_yxd: "",
        other_province: "",
        other_city: "",
        other_area: "",
        other_address: "",

        other_age: 0,
        score: 0,
      },
      other_companystr: '',  // 企业名称
      other_typestr: "",
      other_attrstr: "",
      other_yxdstr: "",

      columnOne: [],
      columnTwo: [],
      columnThree: [],

      customerOptin: [],
      customerQy: [],

      isType: 1,
      provinceList: [],
      provinceTxt: "",
      cityList: [],
      cityTxt: "",
      areaList: [],
      areaTxt: "",
      loading: true,
      isShowPopup: false,
    };
  },
  created() {
     let { routerList, USERINFO } = this.$store.state;
    let { name } = this.$route;
    this.qyguid = USERINFO.qy.qyguid;
    this.getCustomQyList(true)
    this.getCustomerLabel();

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }    
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id, type } = JSON.parse(res.jsondata);
        this.type = type
        if (id) {
          this.id = id;
          this.getCustomerDetail(id);
        }
      } else {
        this.$router.back();
      }
    },

    // 获取客户详情
    getCustomerDetail() {
      getCustomerDetail({ id: this.id }).then((res) => {
        this.formData.appid = res.appid;
        this.formData.guid = res.guid;
        this.formData.info_remark = res.info_remark ? res.info_remark : res.ext_name;  // 企业员工姓名
        this.formData.ext_name = res.ext_name;  // 客户昵称
        this.formData.info_truename = res.info_truename ? res.info_truename : res.ext_name;  // 客户真实姓名
        this.formData.other_company = res.other_company;
        this.other_companystr = res.other_companystr;
        this.formData.other_job = res.other_job;
        this.formData.info_remark_mobiles = res.info_remark_mobiles;
        this.formData.info_mobile = res.info_mobile;
        this.formData.info_tag_id = res.info_tag_id;
        this.formData.other_type = res.other_type;
        this.other_typestr = res.other_typestr;
        this.formData.other_attr = res.other_attr;
        this.other_attrstr = res.other_attrstr;
        this.formData.other_yxd = res.other_yxd;
        this.other_yxdstr = res.other_yxdstr;
        this.formData.other_province = parseInt(res.other_province);
        this.provinceTxt = res.other_provincename;
        this.formData.other_city = parseInt(res.other_city);
        this.cityTxt = res.other_cityname;
        this.formData.other_area = parseInt(res.other_area);
        this.areaTxt = res.other_areaname;
        this.formData.other_address = res.other_address;
      });
    },
    // 获取客户标签
    getCustomerLabel() {
      let params = {
        pageindex: 1,
        pagesize: 100,
        keyword: "",
      };
      getCustomerLabel(params).then((res) => {
        this.customerOptin = res.list;
      });
    },

    // 获取城市
    getProvince(isClick) {
      getProvince().then((res) => {
        let newProvince = [];
        res.forEach((v) => {
          newProvince.push({
            text: v.areaname,
            id: v.areaid,
          });
        });
        this.provinceList = newProvince;
        this.loading = false;
        if (isClick) {
          this.isShowPopup = true;
        }
      });
    },
    // 获取城市
    getCity(isClick) {
      getCity(this.formData.other_province).then((res) => {
        let newcity = [];
        res.forEach((v) => {
          newcity.push({
            text: v.cityname,
            id: v.cityid,
          });
        });
        this.cityList = newcity;
        this.loading = false;
        if (isClick && newcity.length > 0) {
          this.isShowPopup = true;
        } else {
          this.$toast("暂无数据");
        }
      });
    },
    // 获取区域
    getArea(isClick) {
      getArea(this.formData.other_city).then((res) => {
        let newarea = [];
        res.forEach((v) => {
          newarea.push({
            text: v.addrname,
            id: v.addrid,
          });
        });
        console.log();
        this.areaList = newarea;
        this.loading = false;
        if (isClick && newarea.length > 0) {
          this.isShowPopup = true;
        } else {
          this.$toast("暂无数据");
        }
      });
    },

    // 企业
    getCustomQyList(isTrue) {
      getCustomQyList({ qyguid: this.qyguid }).then((res) => {
        let newArr = [];
        res.list.forEach((v) => {
          newArr.push({
            text: v.bodyname,
            id: v.id,
          });
        });
        this.customerQy = newArr;
        if(!isTrue) {
          this.isShowPopup = true;
        }
        
      });
    },

    getQywxset(isShow) {
      let { isType } = this;
      let columncode = "";
      if (isType == 4) {
        columncode = "classid"; // 补充分类
      } else if (isType == 5) {
        columncode = "userattr"; // 客户属性
      } else if (isType == 6) {
        columncode = "contactsort"; // 联系优先度
      }
      getQywxset(columncode).then((res) => {
        res.forEach((item) => {
          if (isType == 4) {
            this.columnOne.push({
              text: item.evalue,
              id: item.id,
            });
          } else if (isType == 5) {
            this.columnTwo.push({
              text: item.evalue,
              id: item.id,
            });
          } else if (isType == 6) {
            this.columnThree.push({
              text: item.evalue,
              id: item.id,
            });
          }
        });
        if (isShow) {
          this.isShowPopup = true;
        }
      });
    },

    onConfirm(e) {
      let { isType } = this;
      let { text, id } = e;
      console.log(id, text);
      if (isType == 1) {
        this.provinceTxt = text;
        this.formData.other_province = id;
        this.areaTxt = "";
        this.formData.other_area = "";
        this.cityTxt = "";
        this.formData.other_city = "";
        this.formData.other_address = "";
      } else if (isType == 2) {
        this.cityTxt = text;
        this.formData.other_city = id;
        this.areaTxt = "";
        this.formData.other_area = "";
        this.formData.other_address = "";
      } else if (isType == 3) {
        this.areaTxt = text;
        this.formData.other_area = id;
        this.formData.other_address = "";
      } else if (isType == 4) {
        this.formData.other_type = id;
        this.other_typestr = text;
      } else if (isType == 5) {
        this.formData.other_attr = id;
        this.other_attrstr = text;
      } else if (isType == 6) {
        this.formData.other_yxd = id;
        this.other_yxdstr = text;
      } else if (isType == 7) {
        this.formData.other_company = id;
        this.other_companystr = text;
      }
      this.loading = true;
      this.isShowPopup = false;
    },
    // 显示弹窗
    handleShow(type) {
      let { provinceTxt, cityTxt } = this;
      this.isType = type;
      if (type == 1) {
        this.getProvince(true);
      } else if (type == 2) {
        if (provinceTxt == "") {
          this.$toast("请选择省/直辖市");
          return;
        }
        this.getCity(true);
      } else if (type == 3) {
        if (provinceTxt == "") {
          this.$toast("请选择省/直辖市");
          return;
        }
        if (cityTxt == "") {
          this.$toast("请选择城市");
          return;
        }
        this.getArea(true);
      } else if (type == 4) {
        this.getQywxset(true);
      } else if (type == 5) {
        this.getQywxset(true);
      } else if (type == 6) {
        this.getQywxset(true);
      } else if (type == 7) {
        this.getCustomQyList();
      }
    },

    query() {
      let { formData } = this;
      // if (formData.info_truename == "") {
      //   this.$toast("请输入客户姓名");
      //   return;
      // }
      // if (formData.other_company == "") {
      //   this.$toast("请输入企业名称");
      //   return;
      // }
      // if (formData.other_job == "") {
      //   this.$toast("请输入职务");
      //   return;
      // }
      // if (formData.info_mobile == "") {
      //   this.$toast("请输入联系方式");
      //   return;
      // }

      if (formData.info_truename == "") {
        this.$toast("请输入客户姓名");
        return;
      }
    //   if (formData.other_company == "") {
    //     this.$toast("请输入企业名称");
    //     return;
    //   }
    //   if (formData.other_job == "") {
    //     this.$toast("请输入职务");
    //     return;
    //   }
      if (formData.info_mobile == "") {
        this.$toast("请输入联系方式");
        return;
      }
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      addCustomer(formData).then((res) => {
        if (res.result) {
          setTimeout(() => {
            Toast.clear();
            this.$toast.success(res.message);
          }, 500);
          setTimeout(() => {
            history.back();
          }, 1500);
        } else {
          this.$toast.fail(res.message || "服务器报错，请稍后～");
        }
      });
    },

    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.indexPage {
  /deep/ .van-cell {
    padding: 0;
    font-size: 12px;
    background: none;
    height: 100%;
  }
  /deep/ .van-field__body {
    height: 100%;
  }
  .head {
    .icon-huiyuan {
      font-size: 42px;
      font-weight: 500;
    }
  }
  .container_wrap {
    padding: 75px 83px 56px;
    .form_wrap {
      font-size: 24px;
      color: #333333;
      .customer_wrap {
        margin: 59px 13px 0;
        .label_list {
          margin-top: 30px;
          .item {
            font-size: 20px;
            color: #464646;
            height: 40px;
            border: 1px solid #d2d2d2;
            padding: 0 10px 0 20px;
            margin-right: 10px;
            min-width: 120px;
            box-sizing: border-box;
            .iconfont {
              font-size: 36px;
              margin-left: 15px;
            }
            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
      .classify_wrap {
        margin: 90px 0 110px;
      }
      .address_wrap {
        .title {
          margin-bottom: 59px;
        }
      }
      .item {
        margin-bottom: 32px;
        .tit {
          margin-bottom: 20px;
        }
        .label {
          margin-bottom: 25px;
          .iconfont {
            color: #c63520;
            margin-left: -12px;
          }
        }
        .input {
          border-bottom: 1px dashed #c3c3c3;
          height: 60px;
          padding: 0 12px;
        }
        .textarea {
          height: 190px;
          background: #fafafa;
          padding: 10px 20px;
          box-sizing: border-box;
          /deep/ .van-field__control {
            height: 100%;
          }
        }
        &.detail {
          margin-top: 70px;
        }
      }
    }
    .custom_btn {
      margin-top: 200px;
      width: 280px;
      height: 50px;
      line-height: 50px;
    }
  }
}
</style>